const GetCountryCode = (locale) => {
  const splitedLocale = locale.split("-");

  return typeof splitedLocale[1] === "undefined" ? locale : splitedLocale[1];
};

export default GetCountryCode;
